export class AllSeriesDataClass1d {
    constructor(data) {
        this.seriesStartName = data.seriesName
        this.seriesStartNumber = data.startNumber
        this.AllSeriesPartName = null
        this.multiply = data.multiply
        this.fieldName = data.fieldName
        this.seriesAllfield = []
        this.printStartNumber = data.printStartNUmber
    }

    addLeadingZeros = (num, totalLength) => {
        return String(num).padStart(totalLength, '0');
      }

    // set series part
    setSeriesPart = () => {
        let ListArray = []
        for (let index = this.seriesStartNumber; index < (this.seriesStartNumber + 10); index++) {
            ListArray.push({name:`${this.fieldName} ${index}`,active:false})
        }
        this.AllSeriesPartName = ListArray
        this.setSeriesField()
    }


    setSeriesField=()=>{
        let mainFieldArray = []
        for (let index = 0; index < 10; index++) {
            let x = []
            for (let i = 0; i < 100; i++) {
                let startNumber = i
                let printNumber = this.addLeadingZeros((this.printStartNumber+(index*100)) + i,2)
                x.push(new seriesFillPart(startNumber,this.multiply,i,printNumber))                
            }
            mainFieldArray.push(x)
            
        }
            
        
        this.seriesAllfield = mainFieldArray
    }

}



class seriesFillPart {
    constructor(name,multiply,number,printNumber){
        this.name = name
        this.index = number
        this.value = null
        this.multiply = multiply
        this.horigetalValue = 0
        this.verticalValue = 0
        this.holdValue = 0
        this.printNumber = printNumber
    }

    
    // setValue
    setValue = (value)=>{
        this.value = value
    }

    getValue = () =>{
        return this.value
    }

    setHoldValue = (value) =>{
        this.holdValue = value
    }

    getHoldValue = ()=>{
        return this.holdValue
    }

    setHorigentalValue = (value)=>{
        this.horigetalValue = value
    }

    getHorigentalValue = () =>{
        return this.horigetalValue
    }

    setVerticalValue = (value)=>{
        this.verticalValue = value
    }

    getVerticalValue = () =>{
        return this.verticalValue
    }

    getFinalValue = () =>{
        return (+this.value||0) + (+this.horigetalValue ||0) + (+this.verticalValue||0)
    }

    resetValue = ()=>{
        this.horigetalValue = 0
        this.verticalValue = 0
        this.holdValue = 0
        this.value = null
    }
    
}